import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Modal,
    Button
} from '@gpstrackit/gtc-react-controls';

import {
    Alert,
    Typography
} from '@mui/material';

import { NotificationManager } from 'Components/Notifications';
//actions
import { accountWebHooksDelete,reset,accountSearchWebHooks } from "../../redux/slice";


import './styles.scss';

const DeleteWebHooks = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { refresh,getData } = props;
    const { openDelete, loading,responseDeleteWebHooks,webHooks,webHookDelete } = useSelector((state) => state.accountWebHooksRedux);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (openDelete && responseDeleteWebHooks && !responseDeleteWebHooks?.error) {
            NotificationManager.success(
                messages['accountWebHooks_successMessage'],
                messages['accountWebHooks_success'],
                3000,
                null,
                null,
                'success',
                null
            );
            setTimeout(() => { dispatch(accountSearchWebHooks({})); }, 500);
            handleClose();
        }
    }, [openDelete, responseDeleteWebHooks]);


    const handleClose = useCallback(() => {
        dispatch(reset());
        getData()
        setErrorMessage("");
    });

    return (
        <Modal
            title={messages['accountWebHooks_deleteTitle']}
            open={openDelete}
            loading={loading}
            position="right"
            size="small"
            handleClose={handleClose}
            footer={(
                <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                    <Button
                        disabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={handleClose}
                        variant='secondary'
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        disabled={loading || !webHookDelete?.length}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            setErrorMessage("");
                            if (webHookDelete?.length) {
                                dispatch(accountWebHooksDelete({
                                    ids: webHookDelete?.map(df => df?.id)
                                }));
                            }
                        }}
                        variant='warning'
                    >
                        {messages['delete']}
                    </Button>
                </div>
            )}
        >
            <div className='delete-forms-container'>
                <Typography
                    variant="subtitle2"
                    color="textSecondary"
                >
                    {messages['accountWebHooks_deleteWarning']}
                </Typography>

                {
                    webHookDelete?.length > 0 &&
                    <ul className='delete-tags-list'>
                        {
                            webHookDelete.map((dynamicForm, key) => {
                                return (
                                    <li 
                                        key={key}
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            listStylePosition: "inside",
                                            whiteSpace: "nowrap"
                                        }}          
                                    >
                                        <span>
                                            {dynamicForm?.name}
                                        </span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                }

                {errorMessage &&
                    <Alert severity="error" onClose={() => setErrorMessage("")}>{errorMessage}</Alert>
                }

            </div>
        </Modal>
    );
}

export default DeleteWebHooks;